export default __webpack_public_path__ + "static/media/documents.a6ccba87.svg";